module.exports = __webpack_public_path__ + "img/fdp-logo.37391ee6.svg";